import { render, staticRenderFns } from "./AdminConfiguration.vue?vue&type=template&id=5d85b1f4&scoped=true"
import script from "./AdminConfiguration.vue?vue&type=script&lang=js"
export * from "./AdminConfiguration.vue?vue&type=script&lang=js"
import style0 from "./AdminConfiguration.vue?vue&type=style&index=0&id=5d85b1f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d85b1f4",
  null
  
)

export default component.exports